//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PageLoader",
  props: {
    path: {
      type: [Boolean, String],
      default: null
    },
    error: {
      type: Boolean,
      default: false
    },
    overlay: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ""
    },
    contentClass: {
      type: String,
      default: ""
    }
  },
  computed: {
    loaderClass() {
      return `${this.path ? "preload" : "preload-moregidge"} ${this.overlay ? "overlay" : ""} ${this.contentClass}`;
    }
  }
});